import _get from 'lodash/get';
// @ts-expect-error TS(7016): Could not find a declaration file for module 'quer... Remove this comment to see the full error message
import queryString from 'query-string';
export const getKeyFromQueryParams = (key: string) =>
  typeof window !== 'undefined' ? _get(queryString.parse(window.location.search), key) : undefined;
